import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShoppingCart, X } from "lucide-react";
import { AnimatedLogo } from "./AnimatedLogo";
import { HeaderBouncer } from "./HeaderBouncer";
import { useCart } from "../../context/CartContext";
import { NAV } from "../../lib/constants";

const linkCls = ({ isActive }) =>
  `font-display text-[1.05rem] font-bold uppercase tracking-wide transition-colors duration-200 ${isActive ? "text-[#E5202A]" : "text-white hover:text-[#60A5FA]"}`;

export const Header = () => {
  const { items } = useCart();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b-2 border-[#2563EB]/80 bg-black/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-20 max-w-7xl items-center gap-4 px-4 sm:px-6">
        <Link to="/" className="shrink-0" data-testid="header-logo-link" onClick={() => setOpen(false)}>
          <AnimatedLogo className="w-12 sm:w-14" testId="header-animated-logo" />
        </Link>
        <HeaderBouncer />
        <nav className="hidden items-center gap-5 xl:flex" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/order" className="btn-red hidden !px-5 !py-2 !text-base sm:inline-flex" data-testid="header-start-order-button">Start Order</Link>
          <Link to="/checkout" className="relative inline-flex items-center gap-2 rounded-full bg-[#E5202A] px-4 py-2 font-display font-bold uppercase text-white transition-transform duration-200 hover:scale-105" data-testid="header-cart-button">
            <ShoppingCart className="h-4 w-4" /> Cart
            <span className="grid h-5 min-w-5 place-items-center rounded-full bg-white px-1 text-xs text-black" data-testid="header-cart-count">{items.length}</span>
          </Link>
          <button className="rounded-full p-2 text-white xl:hidden" onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="mobile-menu-toggle">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-white/10 bg-black/95 px-6 pb-6 pt-2 xl:hidden" data-testid="mobile-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end onClick={() => setOpen(false)} className={(s) => `${linkCls(s)} block border-b border-white/5 py-3 text-xl`} data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/order" onClick={() => setOpen(false)} className="btn-red mt-5 w-full" data-testid="mobile-start-order-button">Start Custom Order</Link>
        </nav>
      )}
    </header>
  );
};
